import { render, staticRenderFns } from "./ReadyMade.vue?vue&type=template&id=6569b9f2&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ReadyMade.vue?vue&type=script&lang=js&"
export * from "./ReadyMade.vue?vue&type=script&lang=js&"
import style0 from "./ReadyMade.vue?vue&type=style&index=0&id=6569b9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569b9f2",
  null
  
)

export default component.exports